import { routes } from '@/constants';
import { Bubble } from '@/routes/bubble';
import { Contexts } from '@/routes/contexts';
import { DebugPrompt } from '@/routes/debugPrompt';
import { ApiTokens } from '@/routes/apiTokens';
import { Home } from '@/routes/home';
import { Metrics } from '@/routes/metrics';
import { NotFound } from '@/routes/notFound';
import { Paragraphs } from '@/routes/paragraphs';
import { Predicts } from '@/routes/predicts';
import { PromptEngineering } from '@/routes/promptEngineering';
import { Reports } from '@/routes/reports';
import { Upload } from '@/routes/upload';
import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';

const App: FC = () => {
  return (
    <Routes>
      <Route path={routes.home}>
        <Route index={true} element={<Home />} />
        <Route path={routes.upload} element={<Upload />} />
        <Route path={routes.predictions} element={<Predicts />} />
        <Route path={routes.paragraphs} element={<Paragraphs />} />
        <Route path={routes.reports} element={<Reports />} />
        <Route path={routes.bubble} element={<Bubble />} />
        <Route path={routes.metrics} element={<Metrics />} />
        <Route path={routes.apiTokens} element={<ApiTokens />} />
        <Route path={routes.contexts} element={<Contexts />} />
        <Route path={routes.promptEngineering} element={<PromptEngineering />} />
        <Route path={routes.debugPrompt} element={<DebugPrompt />} />
        <Route path={routes.notFound} element={<NotFound />} />
      </Route>
    </Routes>
  );
};

export default App;
